// extracted by mini-css-extract-plugin
export default {"component":"incentiveProductDialog__component___6fQwC"};